import { render } from "./bardashboard.vue?vue&type=template&id=6adda6a6"
import script from "./bardashboard.vue?vue&type=script&lang=js"
export * from "./bardashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__